


















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import { setLongFormatDate } from '@/modules/shared/shared/domain/functions/date-functions';
import { Watch } from 'vue-property-decorator';
import { Incident } from '@/modules/reports/shared/domain/incident';
import * as rules from '@/modules/shared/shared/domain/rules';
import moment from 'moment';
import { layout, reportsManagement } from '@/modules/shared/shared/store/namespaces';
import { IncidentsView } from '@/modules/reports/management/domain/incidents.view';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { ReportsManagementActions } from '@/modules/reports/management/store/reports-management.actions';
import { ReportsManagementGetters } from '@/modules/reports/management/store/reports-management.getters';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';

@Component({
    name: 'incident-registry',
    components: { SectionTitle },
})
export default class IncidentRegistry extends Vue {
    dateStartMenu: boolean = false;
    dateEndMenu: boolean = false;

    dateStart: string | null = null;
    dateEnd: string | null = null;
    startHour: string | null = null;
    endHour: string | null = null;

    dateStartSelected: string | null = null;
    dateEndSelected: string | null = null;

    newIncident: Incident = {};

    isLoading: boolean = false;
    isFetchingData: boolean = false;

    rules: any = rules;

    $refs!: {
        form: any;
    };

    setDateStart(date: string) {
        this.dateStart = setLongFormatDate(date);
    }

    setDateEnd(date: string) {
        this.dateEnd = setLongFormatDate(date);
    }

    get fullDateStart() {
        return `${this.dateStartSelected} ${this.startHour}`;
    }

    get fullDateEnd() {
        return `${this.dateEndSelected} ${this.endHour}`;
    }

    get maxDate() {
        return moment()
            .toISOString(true)
            .substr(0, 10);
    }

    checkHours() {
        const start = moment(this.fullDateStart);
        const end = moment(this.fullDateEnd);
        const now = moment();
        if (end.isAfter(now)) {
            return 'La hora de fin debe ser menor a la hora actual';
        }
        return (
            this.dateStartSelected !== this.dateEndSelected ||
            end.isAfter(start) ||
            'La hora de fin debe ser mayor a la hora de comienzo'
        );
    }

    async register() {
        if (this.$refs.form.validate()) {
            this.newIncident.startDate = this.fullDateStart;
            this.newIncident.endDate = this.fullDateEnd;
            this.isLoading = true;
            const failed = await this.createIncident(this.newIncident);
            if (!failed) {
                EventBus.$emit(
                    EventBusMessages.SHOW_SUCCESS,
                    'Se han creado el incidente con éxito',
                );
                this.$refs.form.reset();
            } else {
                (failed as ExceptionMessage).showError();
            }
            this.isLoading = false;
        }
    }

    @Watch('dateStartSelected')
    onDateSelectedChanged() {
        this.dateEndSelected = null;
        this.dateEnd = null;
        this.endHour = null;
    }

    async mounted() {
        this.changeTitle({ title: 'Incidencias', route: ['Registro'] });
        this.isFetchingData = true;
        const failed = await this.fetchView();
        if (failed) {
            (failed as ExceptionMessage).showError();
        }
        this.isFetchingData = false;
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (title: LayoutTitle) => void;

    @reportsManagement.Action(ReportsManagementActions.FETCH_INCIDENT_REGISTRY_VIEW)
    fetchView!: () => Promise<RequestResponse>;

    @reportsManagement.Action(ReportsManagementActions.CREATE_INCIDENT)
    createIncident!: (incident: Incident) => Promise<RequestResponse>;

    @reportsManagement.Getter(ReportsManagementGetters.GET_INCIDENT_REGISTRY_VIEW)
    view!: IncidentsView;
}
